/* eslint-disable */
// @ts-nocheck

import React, { MouseEventHandler } from "react";
import { Button } from "@carbon/react";
import { ReactComponent as AddIcon } from "../../assets/icons/add.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/copy.svg";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as NotificationIcon } from "../../assets/icons/notification.svg";
import { ReactComponent as ProfileIcon } from "../../assets/icons/profile.svg";
import { ReactComponent as BarChart } from "../../assets/icons/barchart.svg";
import { ReactComponent as Upload } from "../../assets/icons/upload.svg";
import { ReactComponent as CloudUpload } from "../../assets/icons/cloudUpload.svg";
import { ReactComponent as CloudDownload } from "../../assets/icons/cloudDownload.svg";
import { ReactComponent as DownArrow } from "../../assets/icons/downArrow.svg";
import { ReactComponent as InfoAlert } from "../../assets/icons/info.svg";
import { ReactComponent as Warning } from "../../assets/icons/warning--filled.svg";
import { ReactComponent as Key } from "../../assets/icons/key.svg";
import Loader from "../../components/loader/Loader";

export enum Icons {
  Add,
  Edit,
  Delete,
  Search,
  Copy,
  Close,
  Notification,
  Profile,
  Chart,
  Upload,
  CloudUpload,
  CloudDownload,
  DownArrow,
  InfoAlert,
  Warning,
  Key,
}

const getIconFromName = (IconName: Icons) => {
  switch (IconName) {
    case Icons.Add:
      return <AddIcon />;
    case Icons.InfoAlert:
      return <InfoAlert />;
    case Icons.Warning:
      return <Warning />;
    case Icons.CloudUpload:
      return <CloudUpload />;
    case Icons.CloudDownload:
      return <CloudDownload />;
    case Icons.Key:
      return <Key />;
    case Icons.DownArrow:
      return <DownArrow />;
    case Icons.Upload:
      return <Upload />;
    case Icons.Edit:
      return <EditIcon />;
    case Icons.Delete:
      return <DeleteIcon />;
    case Icons.Search:
      return <SearchIcon />;
    case Icons.Copy:
      return <CopyIcon />;
    case Icons.Close:
      return <CloseIcon />;
    case Icons.Notification:
      return <NotificationIcon />;
    case Icons.Profile:
      return <ProfileIcon />;
    case Icons.Chart:
      return <BarChart />;
    default:
      return null;
  }
};

export default (props: {
  kind?: string;
  className?: string;
  type?: "submit" | "button";
  disabled?: boolean;
  icon?: Icons;
  label?: string;
  loading?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  dataCy?: string;
  renderIcon?: () => JSX.Element;
  iconDescription?: string;
  hasIconOnly?: boolean;
}) => {
  const {
    kind,
    className,
    type = "button",
    disabled,
    icon,
    label,
    loading,
    onClick,
    dataCy = "",
    renderIcon,
    iconDescription,
    hasIconOnly,
  } = props;

  return (
    <Button
      hasIconOnly={hasIconOnly}
      kind={kind || "primary"}
      data-cy={`${dataCy}button`}
      className={className}
      type={type}
      disabled={loading || disabled}
      onClick={onClick}
      renderIcon={renderIcon}
      iconDescription={iconDescription}
      tooltipAlignment={"end"}
    >
      {loading ? <Loader /> : getIconFromName(icon)}
      {label || null}
    </Button>
  );
};
